<template>
  <draggable
    :id="parent.type+'#'+parent.id"
    :group="{name: 'spatial_structure', pull: true, put: function (to, from, dragEl) {return isValidChildren(dragEl.id)}}"
    animation="300"
    forceFallback="true"
    fallbackOnBody="true"
    :disabled="!isEditMode"
    style="position: relative; height: 100%; display: flex; flex-direction: column; flex-shrink: 0;"
    :value="child_elements"
    filter=".ignore"
    @end="$emit('draggableEnd', $event)"
    @update="$emit('draggableUpdate', {evt: $event, parent: parent})"
    @remove="$emit('draggableRemove', {evt: $event, parent: parent})"
    @add="$emit('draggableAdd', {evt: $event, parent: parent})"
    >
    <TIntersectionWrapper
      :class="`
        project-structure-tree
        ${['elements', 'plans', 'element_wrapper', 'elementassemblies'].includes(element.type)?'font-weight-light':`grey darken-${parent_color_index >=3?3:parent_color_index}`}
        `"
      v-for="element in child_elements"
      min_height="27px"
      :show_always="element.type !== 'elements' && !element.closed || (element.type === 'element_wrapper' && parent.element_wrappers_open.includes(element.id))"
      :key="element.type+element.id"
      :id="element.type+'#'+element.id"
      :style="['elements', 'plans', 'element_wrapper', 'elementassemblies'].includes(element.type)?'padding: 0px; color: rgba(255,255,255,0.9)':`${isEditMode && !element.closed?'padding-bottom: 40px':''}`"
      >
      <div
        class="project-structure-tree-header"
        :style="isEditMode?'cursor: grab;':'cursor: pointer'"
        @click="$emit('treeElementClicked', {element: element, evt: $event})"
        @mouseenter.prevent.stop="$emit('enterElement', element)"
        @mouseleave.prevent.stop="$emit('leaveElement', element)"
        >
        <!-- :style="marker_color?`background-color: ${marker_color} !important`:''" -->
        <StandardDeleteButton
          class="project-structure-tree-delete ml-2"
          v-if="isEditMode"
          :zoom="0.8"
          @clickDelete="$emit('deleteTreeElement', element)"
          />
          <!-- :color="isVisible({type: element.type, id: element.id, elements: element.type === 'element_wrapper'?element.elements:[]})?'':'grey darken-3'" -->
          <v-icon
            v-if="show_visibility"
            :color="
            element.type === 'plans'?
            (element.visible?'white':'grey darken-3')
            :
            getVisibility({type: element.type, id: element.id, element_ids: element.type === 'element_wrapper'?element.element_ids:[]}).color
            "
            class="project-structure-tree-visibility"
            small
            @click.prevent.stop="
            element.type === 'plans'?
            $emit('togglePlanVisibility', element)
            :
            $emit('toggleVisibility', getVisibility({type: element.type, id: element.id, element_ids: element.type === 'element_wrapper'?element.element_ids:[]}))
            "
            >
            visibility
          </v-icon>
        <div
          :class="`project-structure-tree-marker ${marker_color?marker_color:''}`"
          v-if="selected_tree_element && selected_tree_element.type === element.type && selected_tree_element.id === element.id"
        />
        <div
          v-if="!['elements', 'plans'].includes(element.type) && arrayIncludesArray(all_selected_elements, element.type === 'element_wrapper'?element.element_ids:getAllChildElements({parent_type: element.type, parent_id: element.id})).includes"
          class="project-structure-tree-wrapper-marker"
          :style="
            arrayIncludesArray(ta_hovered_elements, element.type === 'element_wrapper'?element.element_ids:getAllChildElements({parent_type: element.type, parent_id: element.id})).includes
            ||
            arrayIncludesArray(hover_el_ids, element.type === 'element_wrapper'?element.element_ids:getAllChildElements({parent_type: element.type, parent_id: element.id})).includes
            ?
            'background-color: #009688'
            :
            ''"
          />
        <!-- <div v-else style="width: 24px"/> -->
        <v-btn icon
          @click.prevent.stop="$emit('closeWrapper', element)"
          style="height: 24px; width: 24px"
          v-if="!['elements', 'plans'].includes(element.type)"
          >
          <v-icon
            class="cursor-pointer"
            :color="['element_wrapper', 'elementassemblies'].includes(element.type)?'':'rgba(0,0,0,0.9)'"
            >
            {{!element.closed || (element.type === 'element_wrapper' && parent.element_wrappers_open.includes(element.id))?'keyboard_arrow_down':'keyboard_arrow_right'}}
          </v-icon>
        </v-btn>
        <v-btn icon
          v-else-if="select_spatial_el_ta_id !== -1"
          @click.prevent.stop="ta_selected_elements.includes(parseInt(element.id))?
          $emit('removeElement', element)
          :
          !train_selected_elements.includes(parseInt(element.id))?
          $emit('addElement', element)
          :''
          "
          :style="`height: 24px; width: 24px; margin-left: -24px; ${!ta_selected_elements.includes(parseInt(element.id)) && train_selected_elements.includes(parseInt(element.id))?'cursor: default':''}`"
          >
          <v-icon
            :color="ta_selected_elements.includes(parseInt(element.id)) || !train_selected_elements.includes(parseInt(element.id))?'blue':'rgba(255,255,255,0.9)'"
            >
            {{ta_selected_elements.includes(parseInt(element.id)) || train_selected_elements.includes(parseInt(element.id))?'check_box':'check_box_outline_blank'}}
          </v-icon>
        </v-btn>
        <div
          v-else-if="all_selected_elements.includes(parseInt(element.id))"
          class="project-structure-tree-element-marker"
          :style="ta_hovered_elements.includes(parseInt(element.id)) || arrayIncludesArray(hover_el_ids, [parseInt(element.id)]).includes?'background-color: #009688':''"
          />
        <v-icon :color="!['elements', 'plans'].includes(element.type)?'rgba(0,0,0,0.9)':''">
          {{getElementsIcon(element.type)}}
        </v-icon>
        <div
          class="ml-1"
          v-if="!isEditMode || element.type === 'element_wrapper'"
          >
          {{element.name}}{{element.type === 'element_wrapper'?`s (${element.elements.length})`:''}}
        </div>
        <input
          v-else
          class="project-structure-tree-input-field ml-1"
          :value="element.name"
          @change="$emit('changeValue', {
            key: 'name',
            value: $event.target.value,
            element: element
            })"
          />
        <!-- workpackages -->
        <TFlex
          v-if="$route.name === 'ProjectStructure'"
          style="position: absolute; right: 0px; overflow: hidden"
          width="60%"
          >
          <!-- <template
            v-for="workpackage in getUObjects({type: 'testworkpackages', ids: getAllSpatialUnitsWorkpackageIds})"
            >
            <WorkPackage
              v-if="element.type === 'sites'"
              style="cursor: pointer"
              :key="workpackage.id"
              :color="workpackage.color"
              :token="workpackage.token"
              :icon="workpackage.icon"
              :zoom="0.8"
            />
            <div
              v-else-if="element.type === 'elements'"
              :key="`el${element.id}wp${workpackage.id}`"
              style="display: flex; width: 48px;"
              >
              <div
                v-if="element.workpackages.includes(workpackage.id)"
                :style="`height: 20px; width: ${getWidth(element) * workpackage.time_effort}px`"
                :class="`${workpackage.color} lighten-1`"
                />
            </div>
          </template> -->
        </TFlex>
      </div>
      <ProjectStructureTree
        v-if="element.type !== 'elements' && !element.closed || (element.type === 'element_wrapper' && parent.element_wrappers_open.includes(element.id))"
        style="margin-left: 24px"
        @draggableUpdate="$emit('draggableUpdate', $event)"
        @draggableRemove="$emit('draggableRemove', $event)"
        @draggableAdd="$emit('draggableAdd', $event)"
        @closeWrapper="$emit('closeWrapper', $event)"
        @treeElementClicked="$emit('treeElementClicked', $event)"
        @deleteTreeElement="$emit('deleteTreeElement', $event)"
        @changeValue="$emit('changeValue', $event)"
        @addElement="$emit('addElement', $event)"
        @removeElement="$emit('removeElement', $event)"
        @enterElement="$emit('enterElement', $event)"
        @leaveElement="$emit('leaveElement', $event)"
        @clickAddElement="$emit('clickAddElement', $event)"
        @toggleVisibility="$emit('toggleVisibility', $event)"
        @togglePlanVisibility="$emit('togglePlanVisibility', $event)"
        :isEditMode="isEditMode"
        :parent="element"
        :child_elements="element.type === 'element_wrapper'?element.elements:getChildElements({parent_type: element.type, parent_id: element.id})"
        :selected_tree_element="selected_tree_element"
        :marker_color="marker_color"
        :ta_selected_elements="ta_selected_elements"
        :select_spatial_el_ta_id="select_spatial_el_ta_id"
        :all_selected_elements="all_selected_elements"
        :train_selected_elements="train_selected_elements"
        :ta_hovered_elements="ta_hovered_elements"
        :hover_el_ids="hover_el_ids"
        :parent_color_index="parent_color_index + 1"
        :show_visibility="show_visibility"
        />
    </TIntersectionWrapper>
    <TFlex
      v-if="isEditMode && !['elements', 'plans', 'element_wrapper', 'elementassemblies'].includes(parent.type)"
      class="ignore"
      style="position: absolute; bottom: -32px; font-style: italic; color: rgba(0,0,0,0.4);"
      >
      <!-- <div style="overflow: hidden; white-space: nowrap">Drop or Select:</div> -->
      <div style="width: 35px; overflow: hidden; white-space: nowrap">Add:</div>
      <v-chip
        v-for="element in validChildren()"
        :key="element.name"
        :id="element.type+'#-1'"
        style="cursor: pointer"
        color="rgba(0,0,0, 0.2)"
        class="ml-2"
        small
        @click="$emit('clickAddElement', {element: element, parent: parent})"
        >
        <v-icon small color="rgba(255,255,255,0.7)">{{getElementsIcon(element.type)}}</v-icon>
        <div v-if="$route.name === 'ProjectStructure'" class="ml-1" style="color: rgba(255,255,255,0.7)">{{element.name}}</div>
      </v-chip>
    </TFlex>
  </draggable>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';

  import draggable from "vuedraggable";
  import ProjectStructureTree from '@/components/ProjectStructure/ProjectStructureTree.component.vue'
  import TFlex from '@/components/Taktify/TFlex.component.vue'
  import TIntersectionWrapper from '@/components/Taktify/TIntersectionWrapper.component.vue'
  // import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue'
  import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue';
  export default {
    props: [
      'isEditMode',
      'parent',
      'child_elements',
      'selected_tree_element',
      'marker_color',
      'ta_selected_elements',
      'select_spatial_el_ta_id',
      'all_selected_elements',
      'train_selected_elements',
      'ta_hovered_elements',
      'hover_el_ids',
      'parent_color_index',
      'show_visibility'
    ],
    name: 'ProjectStructureTree',
    components: {
      draggable,
      ProjectStructureTree,
      TFlex,
      // WorkPackage,
      StandardDeleteButton,
      TIntersectionWrapper,
    },
    data: () => ({
    }),
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects'
      ]),
      ...mapGetters('ProjectStructure', [
        'getChildElements',
        'getAllChildElements',
        'getAllSpatialUnitsWorkpackageIds',
        'getVisibility'
      ]),
    },
    methods: {
      arrayIncludesArray(array1, array2) {
        if (array1.length === 0 || array2.length === 0) {
          return {includes: false, complete: false};
        }
        let id_is_string = (typeof array1[0] === 'string' || array1[0] instanceof String);
        let set1 = new Set(array1);
        let set2 = new Set(array2);
        function isSuperset(set, subset, id_is_string) {
            for (var elem of subset) {
              if (!id_is_string) {
                if (!set.has(parseInt(elem))) {
                    return false;
                }
              } else {
                if (!set.has(`${elem}`)) {
                    return false;
                }
              }

            }
            return true;
        }

        if (isSuperset(set1, set2, id_is_string)) {
          return {includes: true, complete: true};
        }

        function intersection(setA, setB, id_is_string) {
            var _intersection = new Set();
            for (var elem of setB) {
              if (!id_is_string) {
                if (setA.has(parseInt(elem))) {
                  _intersection.add(parseInt(elem));
                }
              } else {
                if (setA.has(`${elem}`)) {
                  _intersection.add(`${elem}`);
                }
              }
            }
            return _intersection;
        }
        let element_intersection = intersection(set1, set2, id_is_string);

        if (element_intersection.size === 0) {
          // console.log('getVisibility end');
          return {includes: false, complete: false};
        } else {
          // console.log('getVisibility end');
          return {includes: true, complete: false};
        }
      },
      getWidth(el) {
        let width = 0;
        switch (el.name) {
          case 'Schlafraum':
            width = 8;
            break;
          case 'Keller':
            width = 6;
            break;
          case 'Bad':
            width = 4;
            break;
          default:
            width = 5;
          break;
        }
        return width;
      },
      getElementsIcon(type) {
        let icon = ''
        switch (type) {
          case 'sites':
            icon = 'select_all';
            break;
          case 'spatialzones':
            icon = 'schema';
            break;
          case 'buildings':
            icon = 'domain';
            break;
          case 'buildingstoreys':
            icon = 'format_line_spacing';
            break;
          case 'spacegroups':
            icon = 'crop_free';
            break;
          case 'elements':
            icon = 'list_alt';
            break;
          case 'plans':
            icon = 'picture_as_pdf';
            break;
        }
        return icon;
      },
      isValidChildren(children_type) {
        let boolean = true;
        switch (this.parent.type) {
          case 'projects':
            boolean = ['sites'].includes(children_type.split('#')[0]);
            break;
          case 'sites':
            boolean = ['sites', 'spatialzones', 'buildings', 'elements', 'plans'].includes(children_type.split('#')[0]);
            break;
          case 'spatialzones':
            boolean = ['spatialzones', 'elements'].includes(children_type.split('#')[0]);
            break;
          case 'buildings':
            boolean = ['buildings', 'buildingstoreys', 'spacegroups', 'elements', 'plans'].includes(children_type.split('#')[0]);
            break;
          case 'buildingstoreys':
            boolean = ['buildingstoreys', 'spacegroups', 'elements', 'plans'].includes(children_type.split('#')[0]);
            break;
          case 'spacegroups':
            boolean = ['spacegroups', 'elements', 'plans'].includes(children_type.split('#')[0]);
            break;
          case 'elements':
            boolean = false;
            break;
          case 'plans':
            boolean = false;
            break;
        }
        return boolean;
      },
      validChildren() {
        let children = [];
        switch (this.parent.type) {
          case 'projects':
            children = [
              {type: 'sites', name: 'Site'},
            ];
            break;
          case 'sites':
            children = [
              {type: 'sites', name: 'Site'},
              {type: 'spatialzones', name: 'Zone'},
              {type: 'buildings', name: 'Building'},
              {type: 'elements', name: 'Element'},
            ];
            break;
          case 'spatialzones':
            children = [
              {type: 'spatialzones', name: 'Zone'},
              {type: 'elements', name: 'Element'},
            ];
            break;
          case 'buildings':
          children = [
            {type: 'buildings', name: 'Building'},
            {type: 'buildingstoreys', name: 'Storey'},
            {type: 'elements', name: 'Element'},
          ];
            break;
          case 'buildingstoreys':
          children = [
            {type: 'buildingstoreys', name: 'Storey'},
            {type: 'spacegroups', name: 'Space'},
            {type: 'elements', name: 'Element'},
            {type: 'plans', name: 'Floor Plan'},
          ];
            break;
          case 'spacegroups':
          children = [
            {type: 'spacegroups', name: 'Space'},
            {type: 'elements', name: 'Element'},
          ];
            break;
          case 'elements':
          children = [];
            break;
          case 'plans':
          children = [];
            break;
        }
        return children;
      },
      ...mapActions('UltraDev', [
        'updateUDObject'
      ]),
    }
  }
</script>
<style>
  .project-structure-tree {
    width: 100%;
    border-radius: 6px;
    margin-top: 3px;
    padding-right: 3px;
    padding-bottom: 3px;
    /* color: rgba(255,255,255, 0.4); */
    color: rgba(0,0,0,0.9);
  }
  .project-structure-tree-header {
    display: flex;
    user-select: none;
    align-items: center;
    white-space: nowrap;
  }
  .project-structure-tree-header:hover .project-structure-tree-delete {
    display: flex;
  }
  .project-structure-tree-delete {
    display: none;
    position: absolute;
    right: 0px;
  }
  .project-structure-tree-visibility {
    display: flex;
    position: absolute !important;
    right: 24px;
    cursor: pointer;
  }
  .project-structure-tree-marker {
    height: 24px;
    width: 3px;
    position: absolute;
    left: 0px;
    margin-top: 2px;
    background-color: white;
  }
  .project-structure-tree-element-marker {
    position: relative;
    height: 6px;
    width: 6px;
    border-radius: 6px;
    margin-left: -14px;
    margin-right: 8px;
    flex-shrink: 0;
    background-color: rgba(255,255,255,0.9);
  }
  .project-structure-tree-wrapper-marker {
    position: relative;
    height: 6px;
    width: 6px;
    border-radius: 6px;
    margin-left: -15px;
    margin-right: 9px;
    flex-shrink: 0;
    background-color: rgba(255,255,255,0.9);
  }
  .project-structure-tree-input-field {
    outline: none;
    user-select: none;
  }
  .project-structure-tree-input-field:focus {
    outline: none
  }
</style>
